import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Drawer, Form, Input, InputNumber, message, Row, Select, Space } from "antd";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../firebase/config";
const { Option } = Select;

function CreateSMaterial() {
  const [open, setOpen] = useState(false);

  //material info
  const [material, setMaterial] = useState("");
  const [eurM2, setEurM2] = useState(0);
  const [gM2, setGM2] = useState(0);
  const [stock, setStock] = useState(false);
  const [comment, setComment] = useState("");

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const resetFields = () => {
    setMaterial("");
    setEurM2(0);
    setGM2(0);
    setStock(false);
    setComment("");
  };

  const handleAddMaterial = async (e) => {
    e.preventDefault();
    const ref = collection(db, "secondWarehouse");
    try {
      await addDoc(ref, {
        material: material,
        eurM2: eurM2,
        gM2: gM2,
        stock: stock,
        comment: comment,
        created: serverTimestamp(),
      })
        .then(() => {
          message.success(`Success! Material ${material} has been created.`);
        })
        .then(() => {
          setOpen(false);
          resetFields();
        });
    } catch (err) {
      message.error(err.message);
    }
  };

  const handleOnBlur = (event) => {
    const newValue = event.target.value.replace(/,/g, ".");
    setGM2(Number(newValue));
  };

  const handleOnKeyPress = (event) => {
    if (event.key === ",") {
      event.preventDefault();
    }
  };

  return (
    <>
      <Button type="primary" onClick={showDrawer} icon={<PlusOutlined />}>
        New Material
      </Button>
      <Drawer
        title="Create material"
        width={700}
        onClose={onClose}
        open={open}
        bodyStyle={{
          paddingBottom: 80,
        }}
        extra={
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={handleAddMaterial} type="primary">
              Create
            </Button>
          </Space>
        }
      >
        <Form layout="vertical" style={{ width: "100%" }}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="material"
                label="Material Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter Material Name",
                  },
                ]}
              >
                <Input value={material} placeholder="Please enter Material Name" onChange={(event) => setMaterial(event.target.value)} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="eurM2"
                label="Euro M2"
                rules={[
                  {
                    required: true,
                    message: "Please enter EurM2",
                  },
                ]}
              >
                <InputNumber
                  onKeyPress={handleOnKeyPress}
                  onBlur={handleOnBlur}
                  type="number"
                  onChange={setEurM2}
                  style={{ width: "100%" }}
                  placeholder="Please input EurM2"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="gM2"
                label="Grams M2"
                rules={[
                  {
                    required: true,
                    message: "Please enter Grams M2",
                  },
                ]}
              >
                <InputNumber
                  onKeyPress={handleOnKeyPress}
                  onBlur={handleOnBlur}
                  type="number"
                  onChange={setGM2}
                  placeholder="Please input gM2"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="instock"
                label="In Stock?"
                rules={[
                  {
                    required: true,
                    message: "Please select if it's in stock",
                  },
                ]}
              >
                <Select onChange={setStock} placeholder="Is it in stock?">
                  <Option value={false}>No</Option>
                  <Option value={true}>Yes</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="comment" label="Comment">
                <Input.TextArea value={comment} onChange={(event) => setComment(event.target.value)} rows={2} placeholder="please enter material comments" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
}

export default CreateSMaterial;
